import Vue from 'vue';
import { Lang } from 'laravel-vue-lang';

let locale = BulldeskSettings.locale || navigator.language || 'pt_BR';

if (locale.toLowerCase().indexOf('br') !== -1) {
  locale = 'pt_BR';
} else if (locale.toLowerCase().indexOf('en') !== -1) {
  locale = 'en';
}

Vue.use(Lang, {
  locale,
  fallback: 'pt_BR',
});

export * from 'laravel-vue-lang';
